// REFUND & RESPONDENTS TO REMOVE
export let mockGetRefundInfo = {
  success: true,
  refundAmount: 2500,
  respondentsToRemove: ["First1 Last1", "First2 Last2", "First3 Last3"],
};

// NO REFUND OR RESPONDENTS TO REMOVE
// export let mockGetRefundInfo = {
//   success: true,
//   refundAmount: 0,
//   respondentsToRemove: [],
// };

// REFUND BUT NO RESPONDENTS TO REMOVE
// export let mockGetRefundInfo = {
//   success: true,
//   refundAmount: 2500,
//   respondentsToRemove: [],
// };

// RESPONDENTS, BUT NO REFUND
// export let mockGetRefundInfo = {
//   success: true,
//   refundAmount: 0,
//   respondentsToRemove: ["Goldilocks", "Mama Bear", "Papa Bear", "Baby Bear"],
// };

// ERROR
// export let mockGetRefundInfo = {
//   success: false,
//   error: true,
// };
